import Component from '../abstracts/Component';
import TrackingComponent from './TrackingComponent';
import WishlistLogic from "../logics/WishlistLogic";
import OnDemandLiveRegion from "../utils/OnDemandLiveRegion";

export default class CarouselComponent extends Component {
  get SELECTORS() {
    return {
      carouselWrapper: '[data-carousel]',
      wishlistButton: '[data-js-wishlist]',
      slide: '[data-item]',
      nextArrow: '.arrow-next',
      prevArrow: '.arrow-prev',
    };
  }

  get COMPONENTNAME() {
    return 'CarouselComponent';
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.carouselWrapper = this.$component.querySelector(this.SELECTORS.carouselWrapper);
    this.trackingComponent = new TrackingComponent();
    this.wishlistLogic = new WishlistLogic();
    this.nextArrow = this.$component.querySelector(this.SELECTORS.nextArrow);
    this.prevArrow = this.$component.querySelector(this.SELECTORS.prevArrow);
    this.slides = this.$component.querySelectorAll(this.SELECTORS.slide);
    this.titleCardOptions = {
      arrows: false,
      slidesToShow: 1,
      centerMode: true,
      prevArrow: this.prevArrow,
      nextArrow: this.nextArrow,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            centerMode: true,
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            arrows: true,
            centerMode: false,
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 1440,
          settings: {
            arrows: true,
            centerMode: false,
            slidesToShow: 3.5,
          }
        }
      ]
    };
    this.titleCardOptionsUnSlickDesktop = {
      arrows: false,
      slidesToShow: 1,
      centerMode: true,
      prevArrow: this.prevArrow,
      nextArrow: this.nextArrow,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            centerMode: true,
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            arrows: true,
            centerMode: true,
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 1440,
          settings: "unslick",
        }
      ]
    };
    this.titleTopOptions = {
      arrows: true,
      centerMode: true,
      slidesToShow: 1,
      prevArrow: this.prevArrow,
      nextArrow: this.nextArrow,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            centerMode: true,
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            arrows: true,
            centerMode: true,
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 1440,
          settings: {
            arrows: true,
            centerMode: true,
            slidesToShow: 4,
          }
        }
      ]
    };
    this.liveRegion = new OnDemandLiveRegion({
      level: "assertive",
      delay: 1000,
    });
  }

  initCarousel(carouselContainer) {
    if(this.carouselWrapper.dataset.carousel === 'titleCard') {
      $(carouselContainer).slick(this.titleCardOptions);
    }
    if(this.carouselWrapper.dataset.carousel === 'titleTop') {
      if(this.slides.length > 4) {
        $(carouselContainer).slick(this.titleTopOptions);
      } else {
        $(carouselContainer).slick(this.titleCardOptionsUnSlickDesktop);
      }
    }
  }

  importSlick(carousel) {
    this.moduleLoader.loadCarouselAndExecute(
      module => {
        if (carousel) {
          this.initCarousel(carousel);
          this.handleWishlist(carousel);
          this.$emit(this.$customEvents.CAROUSEL.carouselLoaded, {carousel: this.$component});
        } else {
          console.error('Container degli items non trovato.');
        }
      },
      error => {
        console.error("failed to load slick ", error.stack);
      }
    );
  }

  // handle click on wishlist button
  handleWishlist(cardArray) {
    const wishlistButtons = cardArray.querySelectorAll(this.SELECTORS.wishlistButton);
    if (wishlistButtons) {
      wishlistButtons.forEach(btn => {
        const addUrl = btn.dataset.addUrl;
        const removeUrl = btn.dataset.removeUrl;
        const productCode = btn.dataset.code;
        btn.addEventListener("click", () => {
          event.stopPropagation();
          const isAdding = btn.dataset.jsWishlist === "empty";
          const url = isAdding ? addUrl : removeUrl;
          const label = isAdding ? btn.dataset.labelAdded : btn.dataset.labelRemoved;
          fetch(url, {method: 'POST'})
            .then(response => {
              return response.json();
            })
            .then(text => {
              if (isAdding) {
                btn.dataset.jsWishlist = "full";
                this.$emit(this.$customEvents.PRODUCT_EVENTS.addedtowish, {qty: text, elem: btn});
                this.trackingComponent.trackAction('wishlistAdd', {code: productCode});
                btn.setAttribute("aria-label",btn.dataset.labelRemove);
              } else {
                btn.dataset.jsWishlist = "empty";
                this.$emit(this.$customEvents.PRODUCT_EVENTS.removedfromwish, {qty: text.count, elem: btn});
                btn.setAttribute("aria-label",btn.dataset.labelAdd);
              }
              this.liveRegion.sayMessage(label);
            })
            .catch(error => this.warn(error));
        });
      });
    }
  }

  render() {
    super.render();
    if (this.carouselWrapper.dataset.editMode == "false") {
      this.importSlick(this.carouselWrapper);
      this.wishlistLogic.render();
    }
  }
}
